import SvgIconCheck from '@assets/images/common/icon/flow/SvgIconCheck';
import SvgIconPencil from '@assets/images/common/icon/flow/SvgIconPencil';
import { brandColors } from '@src/assets/colors/brandColors';

export type StepbarStatus =
  | 'not-begin'
  | 'in-progress'
  | 'in-progress-current'
  | 'completed'
  | 'completed-current';

// ステップバーのアイテム
type statusItemProps = {
  status?: StepbarStatus;
  lineDirection?: 'left' | 'right' | 'both';
  label: string;
  onClick?: (() => void) | false;
  disabled?: boolean;
};
export const StatusItem = ({
  status = 'not-begin',
  lineDirection = 'both',
  label,
  onClick = false,
  disabled = false,
  navTarget,
}: statusItemProps & { navTarget?: string }) => {
  const iconCommonClass = 'z-10 mx-auto grid size-[30px] place-items-center rounded-full';
  return (
    <div
      className='flex flex-col gap-[10px]'
      onClick={!disabled && onClick ? onClick : undefined}
    >
      <div className='flex flex-col gap-[10px]'>
        <div className='relative grid h-8 w-[110px] place-items-center'>
          {/* アイコン */}
          <>
            {status === 'not-begin' && (
              <div className={`border-2 border-gray-200 bg-gray-200 ${iconCommonClass}`}></div>
            )}
            {status === 'in-progress' && (
              <div className={`border-2 border-primary-500 bg-white ${iconCommonClass}`}>
                <SvgIconPencil
                  color={brandColors['500']}
                  style={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              </div>
            )}
            {status === 'in-progress-current' && (
              <div className={`bg-primary-500 ${iconCommonClass}`}>
                <SvgIconPencil
                  color='#fff'
                  style={{
                    width: '16px',
                    height: '16px',
                  }}
                />
              </div>
            )}
            {status === 'completed' && (
              <div className={`border-2 border-primary-500 bg-white ${iconCommonClass}`}>
                <SvgIconCheck
                  color={brandColors['500']}
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
              </div>
            )}
            {status === 'completed-current' && (
              <div className={`bg-primary-500 ${iconCommonClass}`}>
                <SvgIconCheck
                  color='#fff'
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                />
              </div>
            )}
          </>
          {/* 線 */}
          <>
            <div
              className={`absolute top-1/2 h-[2px] -translate-y-1/2 ${
                status === 'not-begin' ? 'bg-gray-200' : 'bg-primary'
              } ${
                {
                  left: 'left-0 w-[40px]',
                  right: 'right-0 w-[40px]',
                  both: 'left-[50%] -translate-x-1/2 w-[110px]',
                }[lineDirection] || ''
              }`}
            ></div>
          </>
        </div>
        {/* ラベル */}
        {!disabled && onClick ? (
          <button
            className='mx-auto text-[10px] text-primary-500 underline hover:no-underline'
            type='button'
            data-nav-target={navTarget}
          >
            {label}
          </button>
        ) : (
          <span className='mx-auto text-[10px] text-gray-200'>{label}</span>
        )}
      </div>
    </div>
  );
};

// ステップバーの親要素
export const StatusParent = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className='dx-diagnosis-step sticky inset-x-0 top-0 bg-white py-[20px] lg:top-[61px]'>
      <div className='flex justify-center'>{children}</div>
      <p className='mt-[20px] text-center text-sm'>設問の回答はすべて必須です。</p>
    </div>
  );
};

export default { StatusItem, StatusParent };
